import React from "react";
import PropTypes from "prop-types";
import APILink from "components/ui/APILink";

export function SectionTitle({ title, links = [] }) {
  return (
    <div
      style={{
        display: `flex`,
        justifyContent: `space-between`,
        alignItems: `center`,
        padding: `var(--lg) var(--lg)`,
      }}
    >
      <h3 style={{ margin: 0, padding: 0, fontSize: `14px` }}>{title}</h3>
      {links?.length > 0 && (
        <div style={{ fontWeight: `bold` }}>
          {links.map((link, index) => (
            <APILink
              key={index}
              link={link}
              decoration={<i className="fa fa-arrow-right" />}
            />
          ))}
        </div>
      )}
    </div>
  );
}

SectionTitle.displayName = "SectionTitle";
SectionTitle.propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.object),
};
